module.exports = __webpack_public_path__ + "img/fun05.5320687e.png";